import { Action, Module, VuexModule } from "vuex-module-decorators";
import { LawExams } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class LawExamsModule extends VuexModule {
    @Action
    [LawExams.findPageLawExams](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawExams/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawExams.saveLawExams](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawExams/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawExams.deleteLawExams](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/lawExams/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}